import React from 'react';
import { Box, Button, Copy, Icon, IconWrapper, Link, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import gtmDealerInventoryBuyNow from '../../../../../../core/gtm/dealer_inventory/gtmDealerInventoryBuyNow';
import tableStyles from './DealerInventoryTable.styles';
import themeStyles from '../DealerInventoryModalContent.styles';
var StyledButton = themeStyles.apply(Button, 'StyledButton');
var ContactDealerCTA = themeStyles.apply(Link, 'ContactDealerCTA');
var UnavailableText = themeStyles.apply(Copy, 'Text');
var Container = tableStyles.apply(Box, 'Container');
var HeaderRow = tableStyles.apply(Box, 'HeaderRow');
var HeaderCell = tableStyles.apply(Copy, 'HeaderCell');
var TableRow = tableStyles.apply(Copy, 'TableRow');
var TableCell = tableStyles.apply(Copy, 'TableCell');
var CellContent = tableStyles.apply(Box, 'CellContent');
var VerticalCenter = tableStyles.apply(Box, 'VerticalCenter');
var TableCtaWrapper = tableStyles.apply(Box, 'TableCtaWrapper');
var BuyNowWrapper = tableStyles.apply(Box, 'BuyNowWrapper');
var DealerInventoryTable = function (_a) {
    var data = _a.data, availability = _a.availability, setCurrentDealer = _a.setCurrentDealer, paymentUrl = _a.paymentUrl, gtmTagging = _a.gtmTagging, modelCode = _a.modelCode;
    var t = useTranslation().t;
    if (!(data === null || data === void 0 ? void 0 : data.length))
        return null;
    function handleBuyNowClick() {
        var gtmTrimName = gtmTagging.gtmTrimName, gtmBodyStyle = gtmTagging.gtmBodyStyle, price = gtmTagging.price, gtmCategoryName = gtmTagging.gtmCategoryName, discountAmount = gtmTagging.discountAmount;
        gtmDealerInventoryBuyNow({
            productId: modelCode,
            productName: gtmTrimName,
            discountAmount: discountAmount,
            category: gtmCategoryName,
            bodyStyle: gtmBodyStyle,
            price: price,
        });
    }
    var columnTitles = [
        'invModalNameLabel',
        'invModalAddressLabel',
        'invModalCityLabel',
        'invModalPhoneLabel',
        'invModalAvailabilityLabel',
    ];
    var columns = columnTitles.map(function (column) { return (React.createElement(HeaderCell, { as: "th", scope: "col", key: column, "data-testid": "cy-InventoryModalTable-".concat(column) }, t("Shared.Common.".concat(column)))); });
    var rows = data === null || data === void 0 ? void 0 : data.map(function (dealer, i) {
        var dealerOperatingName = dealer.dealerOperatingName, _a = dealer.address, streetAddressLineOne = _a.streetAddressLineOne, city = _a.city, primaryPhone = dealer.contact.primaryPhone, dealerCode = dealer.dealerCode;
        var isAvailable = availability === null || availability === void 0 ? void 0 : availability[dealerCode];
        var buynowCtaUrl = "".concat(paymentUrl, "&mc=").concat(modelCode, "&d=").concat(dealerCode);
        return [
            {
                value: dealerOperatingName,
                shouldTruncate: true,
                styles: {
                    width: '80%',
                },
            },
            {
                value: streetAddressLineOne,
                shouldTruncate: true,
                styles: {
                    width: '80%',
                },
            },
            {
                value: city,
                shouldTruncate: true,
                styles: {
                    width: '80%',
                },
            },
            { value: primaryPhone, shouldTruncate: false, styles: { width: '140px' } },
            {
                render: (React.createElement(TableCtaWrapper, { key: columnTitles[4] },
                    React.createElement(VerticalCenter, null,
                        React.createElement(IconWrapper, { size: "iconWrapper.xs" },
                            React.createElement(Optional, { when: isAvailable },
                                React.createElement(Icon, { name: "cardChecklist" })))),
                    React.createElement(VerticalCenter, null,
                        React.createElement(ContactDealerCTA, { as: "button", styling: "tertiaryLight", onClick: function (e) {
                                e.stopPropagation();
                                setCurrentDealer(dealer);
                            }, style: { marginVertical: 'auto' }, "data-testid": "cy-InventoryModalTableItem-contact-dealer-".concat(i) }, t('Shared.Common.invModalContactDealerButton'))),
                    React.createElement(BuyNowWrapper, null,
                        React.createElement(Optional, { when: !isAvailable },
                            React.createElement(UnavailableText, { "data-testid": "cy-InventoryModalTableItem-unavailable-text-".concat(i) }, t('Shared.Common.invModalCheckDealerLabel'))),
                        React.createElement(Optional, { when: isAvailable },
                            React.createElement(StyledButton, { onClick: handleBuyNowClick, as: "a", href: buynowCtaUrl, target: "_blank", "data-testid": "cy-DealerInventoryTableItem-buy-now-".concat(i), styling: "special" }, t('Shared.Common.buyNowButton')))))),
            },
        ];
    });
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { style: { overflowY: 'auto', height: '456px' } },
            React.createElement(Container, null,
                React.createElement("table", { width: "100%", style: { tableLayout: 'auto', width: '100%' } },
                    React.createElement("thead", null,
                        React.createElement(HeaderRow, { as: "tr" }, columns.map(function (column) { return column; }))),
                    React.createElement("tbody", null, rows.map(function (row, i) { return (
                    // eslint-disable-next-line react/no-array-index-key
                    React.createElement(TableRow, { as: "tr", key: i.toString(), "data-testid": "cy-InventoryModalTableRow-".concat(i) }, row.map(function (cell, j) { return (
                    // eslint-disable-next-line react/no-array-index-key
                    React.createElement(TableCell, { as: "td", key: j.toString() },
                        React.createElement(CellContent, { styles: cell.styles, shouldTruncate: cell.shouldTruncate, "data-testid": "cy-InventoryModalTableCellContent-row".concat(i, "-cell").concat(j) }, cell.render ? cell.render : cell.value))); }))); })))))));
};
export default DealerInventoryTable;
